<template>
  <div class="rooms">
    <va-card :title="$t('rooms.cards.title')">
      <va-list fit>
        <vue-nestable
          v-model="rooms"
          :maxDepth='1'
          keyProp='order'
        >
          <template
            slot-scope="{ item, index }"
          >
            <va-item>
              <va-item-section>
                <vue-nestable-handle
                  :item="item"
                >
                  <va-item-label>
                    {{ item.name }}
                  </va-item-label>
                </vue-nestable-handle>
              </va-item-section>
              <va-item-section side>
                {{index + 1}}
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < rooms.length - 1"/>
          </template>
        </vue-nestable>
      </va-list>
      <va-button
        @click='salvar'
      >
        Salvar
      </va-button>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import 'vue-nestable/example/assets/vue-nestable.css'

export default {
  name: 'rooms',
  components: {
    VueNestable,
    VueNestableHandle,
  },
  methods: {
    salvar () {
      const self = this
      this.rooms.forEach((element, i) => {
        this.$apollo
          .mutate({
            mutation:
              gql`
              mutation MyMutation($order: Int, $id: Int!) {
                update_room_by_pk(pk_columns: {id: $id}, _set: {order: $order}) {
                  id
                }
              }
              `,
            variables: {
              id: element.id,
              order: (i + 1),
            }
            ,
          })
          .then(data => {
            self.showToast(
              self.$t(
                'toasts.successUpdate',
              ),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
            this.$apollo.queries.rooms.refetch()
          })
          .catch(_ => {
            self.showToast(
              self.$t(
                'toasts.errorUpdate',
              ),
              {
                icon: 'fa-check',
                position: 'top-right',
                duration: 1000,
                fullWidth: false,
              },
            )
          })
      })
    },
  },
  data () {
    return {
      rooms: [],
    }
  },
  apollo: {
    rooms: {
      query: gql`
      query MyQuery{
        rooms: room(order_by: {order: asc}) {
          id
          name
          paid
          active
          order
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          data.rooms.forEach((element, i) => {
            element.order = i
          })
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('rooms')) {
      this.$apollo.queries.rooms.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
